import LocalizedStrings from 'localized-strings';

import { RequestsFilterState } from '../../types';

export default new LocalizedStrings({
  en: {
    filters: {
      [RequestsFilterState.Done]: 'Processed',
      [RequestsFilterState.Pending]: 'To be processed ({count})',
      [RequestsFilterState.Processing]: 'Processing',
    },
  },
  fr: {
    filters: {
      [RequestsFilterState.Done]: 'Traitées',
      [RequestsFilterState.Pending]: 'À traiter ({count})',
      [RequestsFilterState.Processing]: 'En traitement',
    },
  },
} as const);
